import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { map, tap } from 'rxjs';

export const roleAdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sharedService = inject(SharedService);

  return sharedService.isAdmin().pipe(
    map(isAdmin => isAdmin || JSON.parse(localStorage.getItem('isAdmin') || 'false')),
    tap(isAdmin => {
      if (!isAdmin) {
        router.navigate(['/login']);
      }
    })
  );
};
